import {networkTaskableAPI} from "../api/BroadtaskAPI";

export default class NetworkTaskable
{
    constructor(networkUID, taskableUID)
    {
        this.networkUID = networkUID;
        this.taskableUID = taskableUID;
    }

    getSettings(force, callback)
    {
        if (this.settings === true && force === false)
        {
            callback(this.settings);
            return;
        }

        const apiCall = networkTaskableAPI.getTaskableSettings(this.networkUID, this.taskableUID);
        apiCall.then(response => {

            this.settings = response.data;

            callback(this.settings);
        })
            .catch((reason) => {
                console.log("NetworkTaskable::getSettings::ERROR::" + reason.response.data);
                callback(null);
            })
    }

    getCommands(force, callback)
    {
        if (this.commands === true && force === false)
        {
            callback(this.commands);
            return;
        }

        const apiCall = networkTaskableAPI.getCommands(this.networkUID, this.taskableUID);
        apiCall.then(response => {

            this.commands = response.data;

            callback(this.commands);
        })
            .catch((reason) => {
                console.log("NetworkTaskable::getCommands::ERROR::" + reason.response.data);
                callback(null);
            })
    }

    getExtensions(force, callback)
    {
        if (this.extensions === true && force === false)
        {
            callback(this.extensions);
            return;
        }

        const apiCall = networkTaskableAPI.getExtensions(this.networkUID, this.taskableUID);
        apiCall.then(response => {

            this.extensions = response.data;

            callback(this.extensions);
        })
            .catch((reason) => {
                console.log("NetworkTaskable::getExtensions::ERROR::" + reason.response.data);
                callback(null);
            })
    }

    getServices(force, callback)
    {
        if (this.services === true && force === false)
        {
            callback(this.services);
            return;
        }

        const apiCall = networkTaskableAPI.getServices(this.networkUID, this.taskableUID);
        apiCall.then(response => {

            this.services = response.data;

            callback(this.services);
        })
            .catch((reason) => {
                console.log("NetworkTaskable::getServices::ERROR::" + reason.response.data);
                callback(null);
            })
    }

    getTaskProcessors(force, callback)
    {
        if (this.taskProcessors === true && force === false)
        {
            callback(this.taskProcessors);
            return;
        }

        const apiCall = networkTaskableAPI.getTaskProcessors(this.networkUID, this.taskableUID);
        apiCall.then(response => {

            this.taskProcessors = response.data;

            callback(this.taskProcessors);
        })
            .catch((reason) => {
                console.log("NetworkTaskable::getTaskProcessors::ERROR::" + reason.response.data);
                callback(null);
            })
    }
}
